import React from "react";

const Phone: React.FC = () => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.7403 18.4036L15.305 15.8389C15.6476 15.4963 16.1867 15.4486 16.5841 15.7258L20.1349 18.2023C20.6454 18.5584 20.7101 19.2894 20.2699 19.7296L19.8836 20.1159C19.1734 20.8261 18.1542 21.1338 17.1981 20.826C15.1331 20.1613 11.3762 18.6179 8.26127 15.503C5.1463 12.388 3.60292 8.63109 2.93822 6.56614C2.63044 5.60999 2.9381 4.59084 3.64837 3.88058L4.03463 3.49432C4.4748 3.05415 5.20585 3.11879 5.56195 3.62937L8.0384 7.18011C8.31561 7.57758 8.26795 8.11661 7.92529 8.45927L5.36064 11.0239" stroke="white" strokeLinecap="round"/>
</svg>
);

export default Phone;
